import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-867c82cc")
const _hoisted_1 = { class: "home" }
const _hoisted_2 = {
  class: "_header",
  ref: "header"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "_img logo" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "brand" }, "Trademark", -1)
const _hoisted_5 = { class: "grid" }
const _hoisted_6 = { class: "grid smaller" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<div class=\"billboard\" data-v-867c82cc><div class=\"meta\" data-v-867c82cc><h1 class=\"_hero\" data-v-867c82cc>Trademark</h1><div class=\"subheader\" data-v-867c82cc><p data-v-867c82cc> Dear IP Australia, </p><p data-v-867c82cc> I, Liam Widdop, the registrant and owner of the registered domain name “<a href=\"https://gochase.me\" data-v-867c82cc>gochase.me</a>”, hereby consent to the use and registration by the applicant of trademark number 2242277. You can authenticate my ownership while maintaining my personal privacy through whois lookups. Please refer to <a href=\"https://gochase.me/trademark/australia\" data-v-867c82cc>https://gochase.me/trademark/australia</a> which contains a page displaying this message. </p></div></div></div>", 1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconButton = _resolveComponent("IconButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_IconButton, {
          text: "Host",
          colored: true,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({path:'/app'})))
        }),
        _createVNode(_component_IconButton, {
          text: "Join",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push({path:'/app/join'})))
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_IconButton, {
          icon: "forward",
          hex: "#FFFFFF",
          colored: true,
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push({path:'/app'})))
        })
      ])
    ], 512),
    _hoisted_7
  ]))
}